import script from "./ChangePasswordCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordCard.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordCard.vue?vue&type=style&index=0&id=2dbd9554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dbd9554"]])

export default __exports__